import { atom, useAtomValue } from "jotai";
import { useLocation } from "react-router";
import { useSupabaseLoader } from "../../../../../server/supabase/hooks";
import { useIsActive } from "./use-is-active";

// This is only used while we are on the inbox page
export const inboxCountAtom = atom<number | null>(null);

export function useInboxCount(really: boolean): number | null {
  const location = useLocation();

  const isActive = useIsActive();

  const inboxPageVal = useAtomValue(inboxCountAtom);

  const { data: count } = useSupabaseLoader(
    async ({ supabase, account_id }) => {
      if (!really) return 0;
      const { data, error } = await supabase
        .from("inbox_unread_count")
        .select("unread_conversation_count")
        .eq("id", account_id)
        .single();

      if (error) {
        console.error("Unable to fetch unread conversation count:", error);
        return null;
      }

      return data.unread_conversation_count;
    },
    // We want to retrieve unread conversation count every time we navigate
    [location, really],
  );

  return isActive("/inbox", true) ? (inboxPageVal ?? count) : count;
}
